import React from "react";

import TaxonomyListItem from "./TaxonomyListItem";
import NoResults from "../../../common/NoResults";
import { SonicTaxonomyData } from "../../../common/classes/SonicTaxonomy";

import styles from "../../management/db-list/DBList.module.scss";

type Props = {
  taxonomies: Array<SonicTaxonomyData>;
};

const TaxonomyList: React.FC<Props> = ({ taxonomies }) => {
  if (taxonomies.length === 0) return <NoResults />;

  return (
    <div className={styles["f-dbList"]}>
      <div
        className={`${styles["f-dbList__category"]} ${styles["head"]} ${styles["taxonomy"]}`}
      >
        <div>タクソノミー名</div>
        <div>登録ターム数</div>
        <div>アクション</div>
      </div>
      {taxonomies.map((taxonomy, i) => (
        <TaxonomyListItem
          key={i}
          name={taxonomy.name}
          count={taxonomy.count}
          slug={taxonomy.slug}
        />
      ))}
    </div>
  );
};

export default TaxonomyList;
